export const environment = {
  production: true,
  url: 'https://piqet-staging-api.ifourtechlab.com/api',
  signalRUrl: 'https://piqet-staging-api.ifourtechlab.com',
  piqetLcaApiUrl: 'https://piqet-staging-api.ifourtechlab.com/api/v1',
  locationPath: location.origin,
  primaryColor: '#00838F',
  // Microsoft Clarity project id — empty string disables tracking.
  clarityProjectId: '',
  // Google Analytics 4 measurement id — empty string disables tracking. PROD only.
  ga4MeasurementId: '',
};
